import { render, staticRenderFns } from "./FarmerShow.vue?vue&type=template&id=28b59ece&scoped=true&"
import script from "./FarmerShow.vue?vue&type=script&lang=js&"
export * from "./FarmerShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b59ece",
  null
  
)

export default component.exports